import MailchimpForm from "./mailchimpForm";
import "./index.scss";

const BecmomeOmniActiveInsider = () => (
  <div className="omniactive-insider">
    <div className="left">
      <div className="title">Become an Omni-Active® Insider</div>
      <div className="text">Get updates and special offers from Omni-Active® Fitness</div>
    </div>
    <div className="right">
      <MailchimpForm />
    </div>
  </div>
);

export default BecmomeOmniActiveInsider;
